import Nullstack from 'nullstack';
export default function IconTrafficCone({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-traffic-cone",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("line", {
    x1: "4",
    y1: "20",
    x2: "20",
    y2: "20"
  }), "   ", Nullstack.element("line", {
    x1: "9.4",
    y1: "10",
    x2: "14.6",
    y2: "10"
  }), "   ", Nullstack.element("line", {
    x1: "7.8",
    y1: "15",
    x2: "16.2",
    y2: "15"
  }), "   ", Nullstack.element("path", {
    d: "M6 20l5 -15h2l5 15"
  }), " ");
}